<div class="container">
  <div class="page-header">
    <div class="page-header-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    </div>
    <div class="page-header-textos">
      <h1>Lista de Parceiros</h1>
      <p>{{ paginado ? 'Todos os parceiros cadastrados' : 'Últimos ' + limiteUltimos + ' cadastros alterados' }}</p>
    </div>
    <button type="button" class="btn primary" (click)="onNovo()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Cadastrar
    </button>
    <div class="header-funcoes" (click)="$event.stopPropagation()">
      <button type="button" class="btn-config" (click)="toggleFuncoesMenu($event)" title="Funções">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
      </button>
      <div class="pcf-funcoes-menu" *ngIf="funcoesMenuAberto">
        <button type="button" class="pcf-funcoes-item" (click)="exportarExcel()" [disabled]="exportando">Exportar Dados para Excel</button>
        <button type="button" class="pcf-funcoes-item" (click)="exportarCsv()" [disabled]="exportando">Exportar Dados para CSV</button>
        <button type="button" class="pcf-funcoes-item" (click)="copiarParaAreaDeTransferencia()" [disabled]="exportando">Copiar Dados para Área de Transferência</button>
        <button type="button" class="pcf-funcoes-item" (click)="abrirValidacao()">Validar Cadastros do Aerosys</button>
      </div>
    </div>
  </div>

  <div class="loading-overlay" *ngIf="exportando">
    <app-loading-indicator></app-loading-indicator>
    <span class="loading-text">Preparando dados... {{ exportandoPct }}%</span>
    <div class="export-barra"><div class="export-barra-preench" [style.width.%]="exportandoPct"></div></div>
  </div>

  <div class="toast-funcoes" *ngIf="avisoFuncoes" [class.toast-erro]="avisoErro">{{ avisoFuncoes }}</div>

  <!-- Função: Validar clientes do Aerosys -->
  <div class="vca-overlay" *ngIf="vcaAberto" (click)="fecharValidacao()">
    <div class="vca-box" (click)="$event.stopPropagation()">
      <div class="vca-header">
        <div>
          <strong>Validar Cadastros do Aerosys</strong>
          <span>Compara todos os cadastros do Aerosys (clientes, fornecedores e demais tipos) com o Sankhya: CPF/CNPJ, tipos, endereços, e-mails, telefones, dados, compradores, fiadores e aeronaves.</span>
        </div>
        <button type="button" class="vca-fechar" (click)="fecharValidacao()" title="Fechar">×</button>
      </div>

      <div class="vca-barra">
        <button type="button" class="btn primary" (click)="iniciarValidacao()" [disabled]="vcaRodando">
          {{ vcaConcluido || vcaResultados.length ? 'Validar novamente' : 'Iniciar validação' }}
        </button>
        <button type="button" class="btn secondary" (click)="vcaPararValidacao()" *ngIf="vcaRodando">Parar</button>
        <label class="vca-opcao" title="Compara o tipo do telefone dos contatos (Celular, Comercial, Fax...) com o do Aerosys. Por padrão não é verificado.">
          <input type="checkbox" [(ngModel)]="vcaVerificarTipoFone" [disabled]="vcaRodando">
          Verificar tipo do telefone (Aerosys x Sankhya)
        </label>
        <div class="vca-progresso" *ngIf="vcaRodando || vcaTotal">
          <div class="export-barra"><div class="export-barra-preench" [style.width.%]="vcaPct"></div></div>
          <span>{{ vcaProcessados }} de {{ vcaTotal }} cadastros ({{ vcaPct }}%)</span>
        </div>
      </div>

      <div class="vca-erro" *ngIf="vcaErro">{{ vcaErro }}</div>

      <div class="vca-resumo" *ngIf="vcaTotal">
        <span class="vca-chip ok">Em ordem: {{ vcaOk }}</span>
        <span class="vca-chip inc">Incompletos: {{ vcaContar('INCOMPLETO') }}</span>
        <span class="vca-chip nao">Não cadastrados: {{ vcaContar('NAO_CADASTRADO') }}</span>
        <span class="vca-chip sem">Sem CPF/CNPJ: {{ vcaContar('SEM_DOCUMENTO') }}</span>
      </div>

      <div class="vca-geral" *ngIf="vcaConcluido && vcaResultados.length">
        <button type="button" class="btn vca-corrigir" (click)="vcaCorrigirSituacao('INCOMPLETO')" [disabled]="vcaRodando || !vcaContar('INCOMPLETO')">
          Corrigir todos os Incompletos ({{ vcaContar('INCOMPLETO') }})
        </button>
        <button type="button" class="btn vca-corrigir" (click)="vcaCorrigirSituacao('NAO_CADASTRADO')" [disabled]="vcaRodando || !vcaContar('NAO_CADASTRADO')">
          Cadastrar todos os Não cadastrados ({{ vcaContar('NAO_CADASTRADO') }})
        </button>
        <button type="button" class="btn vca-corrigir" *ngIf="vcaVerificarTipoFone || vcaTipoFoneIds.length" (click)="vcaAtualizarTipoFoneTodos()" [disabled]="vcaRodando || vcaCorrAberto || !vcaTipoFoneIds.length" title="Grava no Sankhya o tipo do telefone que está no Aerosys, só dos cadastros divergentes">
          Atualizar tipo do telefone de todos ({{ vcaTipoFoneIds.length }})
        </button>
        <button type="button" class="btn secondary" (click)="vcaVerSemDocumento()" [disabled]="!vcaContar('SEM_DOCUMENTO')" title="Sem CPF/CNPJ não há chave para inserir: corrija o documento no Aerosys">
          Ver Sem CPF/CNPJ ({{ vcaContar('SEM_DOCUMENTO') }})
        </button>
      </div>

      <div class="vca-partes" *ngIf="vcaConcluido && vcaResultados.length">
        <div class="vca-partes-titulo">Atualizar por partes <small>(marque o que deseja inserir; só entram os cadastros com diferença nessas partes)</small></div>
        <div class="vca-partes-lista">
          <label class="vca-parte" *ngFor="let c of vcaCategorias" [title]="c.dica" [class.vca-parte-vazia]="!vcaCatContar(c.chave)">
            <input type="checkbox" [checked]="vcaCatSel.has(c.chave)" (change)="vcaCatToggle(c.chave)" [disabled]="vcaRodando">
            {{ c.rotulo }} <span class="vca-parte-n">{{ vcaCatContar(c.chave) }}</span>
          </label>
        </div>
        <button type="button" class="btn vca-corrigir" (click)="vcaCorrigirPorPartes()" [disabled]="vcaRodando || vcaCorrAberto || !vcaCatIds.length">
          Atualizar selecionados ({{ vcaCatIds.length }} cadastro(s))
        </button>
      </div>

      <div class="vca-filtros" *ngIf="vcaResultados.length">
        <select [(ngModel)]="vcaFiltro" (ngModelChange)="vcaLimite = 100" aria-label="Filtrar por situação">
          <option value="TODOS">Todas as situações</option>
          <option value="NAO_CADASTRADO">Não cadastrados</option>
          <option value="INCOMPLETO">Incompletos</option>
          <option value="SEM_DOCUMENTO">Sem CPF/CNPJ</option>
        </select>
        <input type="text" [(ngModel)]="vcaBusca" (ngModelChange)="vcaLimite = 100" placeholder="Filtrar por nome ou CPF/CNPJ...">
        <span class="vca-contagem">{{ vcaFiltrados.length }} registro(s)</span>
      </div>

      <div class="vca-tabela" *ngIf="vcaResultados.length">
        <table class="tabela">
          <thead>
            <tr>
              <th>Situação</th>
              <th>Cadastro (Aerosys)</th>
              <th>CPF/CNPJ</th>
              <th>O que falta</th>
              <th class="vca-col-acao"></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let r of vcaFiltrados | slice:0:vcaLimite; let i = index">
              <tr (click)="vcaExpandido = vcaExpandido === i ? null : i" class="vca-linha" title="Clique para ver os detalhes">
                <td><span class="vca-sit" [ngClass]="r.situacao">{{ vcaRotulo(r.situacao) }}</span></td>
                <td>{{ r.nome || '—' }}</td>
                <td>{{ r.cpfCnpj || '—' }}</td>
                <td>{{ r.resumo || '—' }}</td>
                <td class="vca-col-acao" (click)="$event.stopPropagation()">
                  <button type="button" class="btn secondary vca-acao" *ngIf="r.situacao === 'NAO_CADASTRADO'" (click)="vcaCadastrar(r)">Cadastrar</button>
                  <button type="button" class="btn secondary vca-acao" *ngIf="r.situacao === 'INCOMPLETO'" (click)="vcaAbrir(r)">Abrir</button>
                  <button type="button" class="btn secondary vca-acao" *ngIf="r.situacao === 'INCOMPLETO' && vcaTemTipoFone(r)" (click)="vcaAtualizarTipoFoneLinha(r)" [disabled]="vcaRodando || vcaCorrAberto" title="Atualiza só o tipo do telefone deste cadastro com o do Aerosys">Atualizar tipo tel.</button>
                  <button type="button" class="btn vca-acao vca-corrigir" *ngIf="r.situacao === 'INCOMPLETO'" (click)="vcaCorrigirLinha(r)" [disabled]="vcaRodando || vcaCorrAberto" title="Insere no Sankhya o que falta neste cadastro">Corrigir</button>
                </td>
              </tr>
              <tr *ngIf="vcaExpandido === i" class="vca-detalhe">
                <td colspan="5">
                  <ul>
                    <li *ngFor="let d of r.detalhes">{{ d }}</li>
                  </ul>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <div class="vca-mais" *ngIf="vcaFiltrados.length > vcaLimite">
          <button type="button" class="btn secondary" (click)="vcaLimite = vcaLimite + 100">Mostrar mais 100 (de {{ vcaFiltrados.length }})</button>
        </div>
      </div>

      <div class="lista-vazia" *ngIf="vcaConcluido && !vcaResultados.length">Todos os cadastros do Aerosys estão cadastrados e completos no Sankhya.</div>

      <div class="vca-rodape">
        <button type="button" class="btn secondary" (click)="vcaExportarExcel()" [disabled]="!vcaFiltrados.length">Exportar Excel</button>
        <button type="button" class="btn secondary" (click)="vcaExportarCsv()" [disabled]="!vcaFiltrados.length">Exportar CSV</button>
        <button type="button" class="btn secondary" (click)="fecharValidacao()">Fechar</button>
      </div>
    </div>
  </div>

  <!-- Correção: resumo / confirmação / resultado -->
  <div class="vca-overlay vca-corr-overlay" *ngIf="vcaCorrAberto">
    <div class="vca-box vca-corr-box" (click)="$event.stopPropagation()">
      <div class="vca-header">
        <h3>{{ vcaCorrTitulo }}</h3>
        <button type="button" class="vca-fechar" (click)="vcaCorrFechar()" title="Fechar" [disabled]="vcaCorrFase === 'simulando' || vcaCorrFase === 'executando'">×</button>
      </div>

      <div class="vca-corr-corpo">
        <div class="vca-progresso" *ngIf="vcaCorrFase === 'simulando' || vcaCorrFase === 'executando'">
          <span>{{ vcaCorrFase === 'simulando' ? 'Analisando' : 'Inserindo no Sankhya' }}: {{ vcaCorrProc }} de {{ vcaCorrIds.length }} cadastros...</span>
        </div>

        <div class="vca-erro" *ngIf="vcaCorrErro">{{ vcaCorrErro }}</div>

        <div class="vca-corr-sumario" *ngIf="vcaCorrFase === 'resumo'">
          <p><strong>{{ vcaCorrIds.length }}</strong> cadastro(s) analisado(s).
            Serão inseridos <strong>{{ vcaCorrContar('PLANEJADO') }}</strong> item(ns)<span *ngIf="vcaCorrPorTipo('PLANEJADO')"> ({{ vcaCorrPorTipo('PLANEJADO') }})</span>.</p>
          <p *ngIf="vcaCorrContar('PENDENTE')">
            <strong>{{ vcaCorrContar('PENDENTE') }}</strong> item(ns) não poderão ser inseridos automaticamente e exigem revisão manual (listados abaixo).
          </p>
          <p class="vca-corr-aviso">Somente são inseridos itens que faltam e campos vazios. Nada existente é apagado ou alterado.</p>
        </div>

        <div class="vca-corr-sumario" *ngIf="vcaCorrFase === 'concluido'">
          <p>Inseridos: <strong>{{ vcaCorrContar('OK') }}</strong><span *ngIf="vcaCorrPorTipo('OK')"> ({{ vcaCorrPorTipo('OK') }})</span>.
            Pendentes: <strong>{{ vcaCorrContar('PENDENTE') }}</strong>. Erros: <strong>{{ vcaCorrContar('ERRO') }}</strong>.</p>
          <p class="vca-corr-aviso">A lista de validação foi atualizada com o estado atual dos cadastros.</p>
        </div>

        <div class="vca-tabela" *ngIf="(vcaCorrFase === 'resumo' || vcaCorrFase === 'concluido') && vcaCorrExibir.length">
          <table class="tabela">
            <thead><tr><th>Cadastro</th><th>Itens</th></tr></thead>
            <tbody>
              <tr *ngFor="let c of vcaCorrExibir | slice:0:100">
                <td>{{ c.nome }}<br><small>{{ c.cpfCnpj }}</small></td>
                <td>
                  <ul class="vca-corr-itens">
                    <li *ngFor="let a of c.acoes" [ngClass]="'st-' + a.status">
                      <span class="vca-corr-st">{{ a.status === 'OK' ? 'Inserido' : a.status === 'PLANEJADO' ? 'Será inserido' : a.status === 'PENDENTE' ? 'Pendente' : 'Erro' }}</span>
                      {{ a.texto }}<span *ngIf="a.erro"> -- {{ a.erro }}</span>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="vca-mais" *ngIf="vcaCorrExibir.length > 100">Mostrando 100 de {{ vcaCorrExibir.length }} cadastros.</div>
        </div>
      </div>

      <div class="vca-rodape">
        <button type="button" class="btn vca-corrigir" *ngIf="vcaCorrFase === 'resumo' && vcaCorrContar('PLANEJADO') > 0" (click)="vcaCorrConfirmar()">Confirmar e inserir no Sankhya</button>
        <button type="button" class="btn secondary" (click)="vcaCorrFechar()" [disabled]="vcaCorrFase === 'simulando' || vcaCorrFase === 'executando'">
          {{ vcaCorrFase === 'concluido' ? 'Fechar' : 'Cancelar' }}
        </button>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="lista-toolbar">
      <div class="field field-wide">
        <input type="text" [(ngModel)]="termoBusca" (ngModelChange)="onTermoBuscaChange()"
          aria-label="Pesquisar na lista de parceiros"
          placeholder="Pesquisar por código, nome, razão social ou CPF/CNPJ...">
      </div>
      <button type="button" class="btn secondary" (click)="onAtualizar()" [disabled]="carregando"
        title="Recarregar a lista de parceiros">
        Atualizar
      </button>
    </div>

    <div class="lista-carregando" *ngIf="carregando">
      <app-loading-indicator size="inline"></app-loading-indicator>
      <span>Carregando parceiros...</span>
    </div>

    <div class="lista-erro" *ngIf="erro && !carregando">{{ erro }}</div>

    <ng-container *ngIf="!carregando && !erro">
      <div class="lista-vazia" *ngIf="!parceiros.length">Nenhum parceiro encontrado.</div>

      <div class="tabela-card" *ngIf="parceiros.length">
        <table class="tabela">
          <thead>
            <tr>
              <th>Código</th>
              <th class="col-status">Status</th>
              <th>Nome</th>
              <th>Tipo</th>
              <th>Tipo Cadastro</th>
              <th>CPF/CNPJ</th>
              <th>Razão Social</th>
              <th>Cidade</th>
              <th>UF</th>
              <th>Cadastro</th>
              <th>Alteração</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of parceiros" (click)="linhaSelecionada = p" (dblclick)="onEditar(p)" title="Duplo clique para editar"
                [class.linha-selecionada]="linhaSelecionada === p">
              <td>{{ p.codparc }}</td>
              <td class="col-status">
                <span class="status-dot" [class.inativo]="p.ativo === 'N'"
                      [title]="p.ativo === 'N' ? 'Inativo' : 'Ativo'"
                      [attr.aria-label]="p.ativo === 'N' ? 'Inativo' : 'Ativo'"></span>
              </td>
              <td>{{ p.nomeparc || '—' }}</td>
              <td>{{ tipoPessoa(p) }}</td>
              <td>{{ tipoCadastro(p) }}</td>
              <td>{{ documento(p) }}</td>
              <td>{{ p.razaosocial || '—' }}</td>
              <td>{{ p.nomecid ? (p.nomecid | uppercase) : '—' }}</td>
              <td>{{ p.siglauf || '—' }}</td>
              <td>{{ p.dtcad || '—' }}</td>
              <td>{{ p.dtalteracao || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lista-paginacao" *ngIf="parceiros.length && paginado">
        <div class="paginacao-info">
          {{ totalRegistros }} parceiro(s) — página {{ paginaAtual }} de {{ totalPaginas }}
        </div>
        <div class="paginacao-controles">
          <button type="button" class="btn-pag" (click)="irParaPagina(1)"
            [disabled]="paginaAtual === 1" title="Primeira página">«</button>
          <button type="button" class="btn-pag" (click)="irParaPagina(paginaAtual - 1)"
            [disabled]="paginaAtual === 1" title="Página anterior">‹</button>

          <ng-container *ngIf="paginas[0] > 1">
            <button type="button" class="btn-pag" (click)="irParaPagina(1)">1</button>
            <span class="btn-pag-reticencias" *ngIf="paginas[0] > 2">…</span>
          </ng-container>

          <button type="button" class="btn-pag" *ngFor="let p of paginas" [class.ativo]="p === paginaAtual"
            (click)="irParaPagina(p)">{{ p }}</button>

          <ng-container *ngIf="paginas[paginas.length - 1] < totalPaginas">
            <span class="btn-pag-reticencias" *ngIf="paginas[paginas.length - 1] < totalPaginas - 1">…</span>
            <button type="button" class="btn-pag" (click)="irParaPagina(totalPaginas)">{{ totalPaginas }}</button>
          </ng-container>

          <button type="button" class="btn-pag" (click)="irParaPagina(paginaAtual + 1)"
            [disabled]="paginaAtual === totalPaginas" title="Próxima página">›</button>
          <button type="button" class="btn-pag" (click)="irParaPagina(totalPaginas)"
            [disabled]="paginaAtual === totalPaginas" title="Última página">»</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
